import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Box,
  Typography,
  Avatar,
  Button,
  Paper,
  Stack,
  Fade,
  Rating,
} from "@mui/material";
import { useLocation, useSearchParams } from "react-router-dom";
import { postAsync, PostAsyncAnonymous } from "../core/serviceClient";
import MessagePopup from "./common/MessagePopUp";
import Loader from "./common/Loader";
import Utils from "../core/Utils";
import { connectToStore } from "../data/store";
import handDown from "../images/hand-down.webp";

const ReviewSection = ({ title, handleRating, ratingValue, reviewSubmited, serviceImageUrl }) => (
  <Paper
    elevation={3}
    sx={{
      p: 3,
      borderRadius: "12px",
      background: "rgba(255,255,255,0.85)",
      backdropFilter: "blur(8px)",
      boxShadow: "0px 3px 8px rgba(0,0,0,0.05)",
      border: "1px solid #e2e8f0",
    }}
  >
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="h6" fontWeight={700}>
        {title}
      </Typography>
      {serviceImageUrl && <img src={serviceImageUrl} alt="" height="60" />}
    </Stack>
    <Rating
      value={ratingValue}
      onChange={(e, val) => !reviewSubmited && handleRating(val)}
      precision={1}
      size="large"
      readOnly={reviewSubmited}
      sx={{
        fontSize: "2.5rem",
        mt: 2,
        "& .MuiRating-iconFilled": { color: "#facc15" },
      }}
    />
  </Paper>
);

const ReviewPage = () => {
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");
  const [overAllRating, setOverAllRating] = useState(0);
  const [businessDetail, setBusinessDetail] = useState({});
  const [branchLogoURL, setBranchLogoURL] = useState({});
  const [branchDetails, setBranchDetails] = useState({});
  const [visitorDetails, setVisitorDetails] = useState({});
  const [reviewSubmited, setReviewSubmitted] = useState(false);
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [copied, setCopied] = useState(false);

  const location = useLocation();
  const [searchParams] = useSearchParams();

  document.getElementsByTagName('body')[0].style.padding = '0';

  useEffect(() => {
    const encryptedData = searchParams.get("data");
    if (encryptedData) {
      getDecryptedData(decodeURIComponent(encryptedData));
    }
  }, [searchParams, reviewSubmited]);

  const getDecryptedData = async (encryptedData) => {
    const result = await PostAsyncAnonymous("Branch/GetDecryptedString", {
      Data: { EncryptedData: encryptedData },
    });
    if (!Utils.IsNullOrEmptyArray(result.data)) {
      const [businessId, branchId, visitId] = result.data.split("#");
      GetBranchDetails(businessId, branchId);
      getVisitorDetails(visitId, businessId);
    }
  };
  const GetBranchDetails = async (BusinessId, BranchId) => {
    var requestBody = {
      BusinessId: BusinessId,
      BranchId: BranchId,
    };
    let result = await PostAsyncAnonymous(
      "Branch/GetBranchInformation",
      requestBody
    );

    if (!Utils.IsNullOrEmptyArray(result.data)) {
      const business = result.data.business;
      const branchinfo = result.data.branch;
      const branchLogo = result.data.logoUrl;
      setBusinessDetail(business);
      setBranchDetails(branchinfo);
      setBranchLogoURL(branchLogo);
    }
  }

  const getVisitorDetails = async (vId, bId) => {
    try {
      setIsLoading(true);
      var request =
      {
        Data: { BusinessId: bId, CustomerVisitId: vId }
      }
      const result = await PostAsyncAnonymous(
        "Branch/GetCustomerVisitDetails",
        request
      );

      if (result?.data) {
        setVisitorDetails(result.data);
        setOverAllRating(result.data.overAllRating || 0);
        setComment(result.data.reviewComment || "");
        setReviewSubmitted(result.data.reviewSubmited || false);
      }
    } catch (error) {
      console.error("Error fetching visitor details:", error);
      setMsgText("Failed to load visitor details.");
      setMsgOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();

    if (reviewSubmited) return;

    try {
      setIsLoading(true);

      const request = {
        Data: {
          ...visitorDetails,
          overAllRating,
          reviewComment: comment,
          reviewSubmited: true,
        },
      };

      const result = await PostAsyncAnonymous(
        "Branch/SaveCustomerVisitDetails",
        request
      );
      if (result?.data === true || result?.success === true) {
        setReviewSubmitted(true);

        if (overAllRating >= 3 && businessDetail?.googleReviewURL) {
          window.open(businessDetail.googleReviewURL, "_blank");
        }
      } else {
        setMsgText("Could not save your review. Please try again.");
        setMsgOpen(true);
      }
    } catch (error) {
      console.error("Error submitting review:", error);
      setMsgText("Something went wrong while submitting your review.");
      setMsgOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (overAllRating === 0) {
      setIsDisable(true);
    } else {
      setIsDisable(false);
    }
  }, [overAllRating]);


  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        px: 0,
      }}
      class="review-page"
    >
      <Grid container xs={12}>
        <Grid
          xs={12}
          sm={12}
          md={4}
          alignSelf="center"
          className="text-center login-bg h-100"
        >
          {/* <Box
            component="img"
            src={Login_Bg}
            style={{ "width": "auto", height: "100%" }}
          /> */}
        </Grid>
        <Grid xs={12} sm={12} md={8} sx={{ display: "flex" }} >
          <Container maxWidth="sm" sx={{ alignSelf: "center", padding: "4rem 2rem" }} >
            <Fade in timeout={600}>
              <Paper
                elevation={10}
                sx={{
                  boxShadow: "none"
                }}
              >
                {!reviewSubmited ? (
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <>
                      <Stack alignItems="center" spacing={1} mb={3}>
                        <Avatar
                          src={branchLogoURL}
                          alt={branchDetails.companyName}
                          sx={{
                            width: 90,
                            height: 90,
                            border: "3px solid white",
                            boxShadow: "0px 5px 20px rgba(0,0,0,0.15)",
                          }}
                        />
                        <Typography variant="subtitle2" color="text.secondary" fontSize="16px" fontWeight="bold">
                          {branchDetails?.branchName}
                        </Typography>
                      </Stack>

                      <ReviewSection
                        title="How happy are you with your visit?"
                        ratingValue={overAllRating}
                        reviewSubmited={reviewSubmited}
                        handleRating={(value) => setOverAllRating(value)}
                      />

                      <Box mt={3}>
                        <Typography variant="h6" fontWeight={600} gutterBottom>
                          Suggestions / Feedback
                        </Typography>
                        <textarea
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                          placeholder="Write your thoughts here..."
                          style={{
                            width: "100%",
                            border: "1px solid #e2e8f0",
                            borderRadius: "12px",
                            padding: "12px",
                            background: "rgba(255,255,255,0.9)",
                            outline: "none",
                            boxShadow: "0px 3px 8px rgba(0,0,0,0.05)",
                          }}
                          rows={4}
                        />
                      </Box>

                      <Button
                        className="submit-btn"
                        fullWidth
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={isDisable}
                      >
                        Submit Review
                      </Button>

                    </>
                  </form>
                ) : (
                  <>
                    <Typography variant="h4" fontWeight={700} color="#4CAF50" gutterBottom>
                      🎉 Thank You!
                    </Typography>

                    <Typography variant="h6" color="text.secondary">
                      Your feedback has been submitted successfully. <br /> We look forward to serving you again!
                    </Typography>

                    <Grid sx={{ textAlign: "right", padding: "0 20px" }}>
                      <Box
                        component="img"
                        src={handDown}
                        sx={{ "width": "50px" }}
                      />
                    </Grid>

                    {overAllRating >= 3 && (
                      <>
                        {!Utils.IsNullOrEmpty(comment) && (
                          <Box
                            sx={{
                              mt: 1,
                              p: 2,
                              border: "1px solid #ddd",
                              borderRadius: "12px",
                              backgroundColor: "#f9f9f9",
                              position: "relative",
                            }}
                          >
                            <Typography variant="subtitle1" fontWeight="bold">
                              Your Comment:
                            </Typography>
                            <Typography variant="body1" sx={{ mt: 1 }}>
                              {comment}
                            </Typography>

                            <Button
                              variant="outlined"
                              size="small"
                              sx={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                textTransform: "none",
                                borderRadius: "20px",
                                backgroundColor: copied ? "#e8f5e9" : "#ffffff",
                                borderColor: copied ? "#4caf50" : "#ccc",
                                color: copied ? "#388e3c" : "#000000",
                                transition: "all 0.3s ease-in-out",
                              }}
                              onClick={() => {
                                if (!Utils.IsNullOrEmpty(comment)) {
                                  navigator.clipboard.writeText(comment);
                                  setCopied(true);
                                  setTimeout(() => setCopied(false), 2000);
                                }
                              }}
                            >
                              {copied ? "Copied ✅" : "Copy"}
                            </Button>
                          </Box>
                        )}

                        <Typography component="p" fontWeight="bold" className="req-tag" onClick={() => {
                          if (!Utils.IsNullOrEmptyObject(businessDetail)) {
                            if (overAllRating >= 3 && businessDetail?.googleReviewUrl) {
                              window.open(businessDetail.googleReviewUrl, "_blank");
                            }
                          }
                        }}>
                          We would greatly appreciate it if you could <strong>copy</strong> and <strong>share</strong> the comments on <strong className="link-tag">Google Reviews</strong> as well.
                        </Typography>

                        <Button
                          variant="contained"
                          className="submit-btn"
                          onClick={() => {
                            if (!Utils.IsNullOrEmptyObject(businessDetail)) {
                              if (overAllRating >= 3 && businessDetail?.googleReviewUrl) {
                                window.open(businessDetail.googleReviewUrl, "_blank");
                              }
                            }
                          }}
                        >
                          OK
                        </Button>
                      </>
                    )}
                  </>
                )}
              </Paper>
            </Fade>
          </Container>
        </Grid>
      </Grid>
    </Box >

  );
};

export default ReviewPage;
